export default __webpack_public_path__ + "_/images/knowledge-center/category-withdrawals-4919b441acfadaa34585e820ba330c0e50fed2e5c2b2027415b18b6425534999.png";